import { type FC } from 'react';
import classnames from 'classnames';

import { FormattedMessage } from 'dibs-react-intl';
import { Button } from 'dibs-elements/exports/Button.tsx';
import HeadingLevel from 'dibs-controlled-heading/exports/HeadingLevel.tsx';

import { useTradeApplyHandler } from '../../applyHandler/TradeApplyHandlerProvider.tsx';
import { TradeBenefitsOverviewSections } from './TradeBenefitsOverviewSections.tsx';
import { trackTradeBenefitsEvent } from '../../tradeBenefitsTracking.ts';

import sharedStyles from '../../TradeBenefitsSharedStyles.scss';
import styles from './TradeBenefitsOverview.scss';
import dibsCss from 'dibs-css';

const TradeBenefitsOverview: FC = () => {
    const applyHandler = useTradeApplyHandler();

    const handleApplyClick = (): void => {
        trackTradeBenefitsEvent({
            stepInteractionName: 'apply now clicked',
            trigger: 'benefits overview',
        });
        applyHandler();
    };

    return (
        <div
            className={classnames(styles.container, dibsCss.pyXlarge)}
            data-tn="trade-benefits-overview"
        >
            <HeadingLevel>
                {Heading => (
                    <>
                        <div
                            className={classnames(
                                styles.header,
                                dibsCss.flex,
                                dibsCss.justifyBetween,
                                dibsCss.itemsCenter,
                                dibsCss.mbLarger
                            )}
                        >
                            <Heading className={classnames(sharedStyles.headingLarge, dibsCss.m0)}>
                                <FormattedMessage
                                    id="abt.TradeBenefitsOverview.title"
                                    defaultMessage="Trade 1st <italic>Benefits Overview</italic>"
                                    values={{
                                        italic: content => (
                                            <span
                                                className={classnames(
                                                    sharedStyles.headingLargeItalic,
                                                    dibsCss.textHeaderBannerSmallItalic
                                                )}
                                            >
                                                {content}
                                            </span>
                                        ),
                                    }}
                                />
                            </Heading>
                            <div className={styles.buttonWrapper}>
                                <Button
                                    style="circle"
                                    className={styles.button}
                                    onClick={handleApplyClick}
                                    dataTn="trade-benefits-apply-now"
                                >
                                    <FormattedMessage
                                        id="abt.TradeBenefitsOverview.applyNow"
                                        defaultMessage="Apply Now"
                                    />
                                </Button>
                            </div>
                        </div>
                        <TradeBenefitsOverviewSections />
                    </>
                )}
            </HeadingLevel>
        </div>
    );
};

export { TradeBenefitsOverview };
